import React from 'react';
import {
  Box,
  Card,
  Button,
  TextField,
  MenuItem,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tabs,
  Tab,
  Typography,
  Tooltip
} from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { format } from 'date-fns';
import Client from '../Client';
import Config from '../ClientConfig';
import BackofficeReportsApi from './backofficeReportsApi';
import CategDateChartGroup from './CategDateChartGroup';

function thousandsSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function addDays(date, days) {
  if (date) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    result = format(result, 'yyyy-MM-dd');
    return result;
  }
}

let d = new Date();
const getISODay = d => (d.getDay() + 6) % 7 + 1;

let today = format(d, 'yyyy-MM-dd');
let yesterday = format(new Date(new Date(d).setDate(d.getDate() - 1)), 'yyyy-MM-dd');
let d1Month = format(new Date(d.getFullYear(), d.getMonth(), 1), 'yyyy-MM-dd');
let d1Week = format(new Date(new Date(d).setDate(d.getDate() - getISODay(d) + 1)), 'yyyy-MM-dd');

const period = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'week', label: 'This Week' },
  { value: 'month', label: 'This Month' },
  { value: 'custom', label: 'Custom' }
];

const objectToCsv = function (data) {
  const csvRows = [];
  const headers = Object.keys(data[0]);
  csvRows.push(headers.join(','));

  for (const row of data) {
    const values = headers.map(header => {
      const val = row[header];
      return `"${val}"`;
    });
    csvRows.push(values.join(','));
  }

  return csvRows.join('\n');
};

class CategLocationChartGroup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      saleslocation_list: [],
      page: 0,
      rowsPerPage: -1,
      dateFrom: today,
      dateTo: today,
      category: 0,
      categoryName: "All Categories",
      delivery: 2,
      sx_hidden: { display: 'none' },
      value: "1",
      categorys: [{ 'iref': 0, 'name': "All Categories" }],
      deliverys: [{ 'iref': 2, 'name': "All" }, { 'iref': 0, 'name': "Restaurant" }, { 'iref': 1, 'name': "Delivery" }],
      filterData: {}
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.addDateFrom = this.addDateFrom.bind(this);
    this.addDateTo = this.addDateTo.bind(this);
    this.selectPeriod = this.selectPeriod.bind(this);
    this.selectCategory = this.selectCategory.bind(this);
    this.selectDelivery = this.selectDelivery.bind(this);

    this.queryData = {};
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    let queryData = {
      "category": this.state.category,
      "dateFrom": this.state.dateFrom,
      "dateTo": this.state.dateTo,
      "delivery": this.state.delivery,
      "isForSale": 1,
      "orderBy_name": true
    };

    let data = BackofficeReportsApi.getSalesByCategoryLocation(this.state.client, queryData);

    if (data) {
      this.setState({ saleslocation_list: data });
    }

    this.setState({ filterData: queryData });

    let categorys = this.state.client.getData(Config.API_URL_PRODUCT_CATEGORY, queryData);
    this.setState({ categorys: categorys.productCategories });
  }

  doSync() {
    this.getData();
    this.setState({ page: 0 });
  }

  addDateFrom = (event) => {
    this.setState({ dateFrom: event.target.value });
    this.setState({ dateTo: event.target.value });
  }

  addDateTo = (event) => {
    this.setState({ dateTo: event.target.value });
  }

  selectPeriod = (event) => {
    switch (event.target.value) {
      case "today":
        this.setState({ sx_hidden: { display: 'none' } });
        this.setState({ dateFrom: today }, function () {});
        this.setState({ dateTo: today }, function () {
          this.doSync();
        });
        break;

      case "yesterday":
        this.setState({ sx_hidden: { display: 'none' } });
        this.setState({ dateFrom: yesterday }, function () {});
        this.setState({ dateTo: yesterday }, function () {
          this.doSync();
        });
        break;

      case "week":
        this.setState({ sx_hidden: { display: 'none' } });
        this.setState({ dateFrom: d1Week }, function () {});
        this.setState({ dateTo: today }, function () {
          this.doSync();
        });
        break;

      case "month":
        this.setState({ sx_hidden: { display: 'none' } });
        this.setState({ dateFrom: d1Month }, function () {});
        this.setState({ dateTo: today }, function () {
          this.doSync();
        });
        break;

      default:
        this.setState(
          { sx_hidden: {} },
          function () {
            this.doSync();
          }
        );
    }
  }

  selectCategory = (event) => {
    this.setState(
      {
        category: event.target.value,
        categoryName: this.state.categorys.find((o) => o.iref === event.target.value)
      },
      function () {
        this.doSync();
      }
    );
  }

  selectDelivery = (event) => {
    this.setState(
      { delivery: event.target.value },
      function () {
        this.doSync();
      }
    );
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value });
    this.setState({ page: 0 });
  }

  onDownload = () => {
    const link = document.createElement("a");
    link.download = "categorySales_" + this.state.categoryName.name + "_" + this.state.dateFrom + "_" + this.state.dateTo + ".csv";

    let csvData = objectToCsv(this.state.saleslocation_list.result);
    let csvHeader = "Category Sales\nDate From: " + this.state.dateFrom + "\nDate To: " + this.state.dateTo + "\nCategory: " + this.state.categoryName.name;
    let csv = "\uFEFF" + csvHeader + "\n" + csvData;

    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    link.click();
  };

  render() {
    let categorys = [{ 'iref': 0, 'name': "All Categories" }];

    if (this.state.categorys) {
      Object.keys(this.state.categorys).forEach(key => {
        let fData = this.state.categorys[key];
        let myData = { 'iref': fData.iref, 'name': fData.name };
        categorys.push(myData);
      });
    }

    let deliverys = [
      { 'iref': 2, 'name': "All" },
      { 'iref': 0, 'name': "Restaurant" },
      { 'iref': 1, 'name': "Delivery" }
    ];

    let categorySalesData = [];
    let categorySalesList = [];

    if (this.state.saleslocation_list) {
      if (this.state.saleslocation_list.result) {
        let counter = 0;

        Object.keys(this.state.saleslocation_list.result).forEach(key => {
          let fData = this.state.saleslocation_list.result[key];

          let myData = {
            x: fData.name,
            y: parseInt(fData.value)
          };

          let p = {
            id: counter + 1,
            name: fData.name,
            quantity: thousandsSeparator(fData.quantity),
            value: thousandsSeparator(parseInt(fData.value))
          };

          if (counter < 10) {
            categorySalesData.push(myData);
          }

          counter += 1;
          categorySalesList.push(p);
        });
      }
    }

    const controlSx = {
      '& .MuiInputBase-root': {
        height: 36,
        borderRadius: '12px',
        fontSize: {
          xs: '0.82rem',
          sm: '0.88rem',
        },
        bgcolor: '#fff',
      },
      '& .MuiInputLabel-root': {
        fontSize: {
          xs: '0.76rem',
          sm: '0.82rem',
        },
      },
      '& .MuiSelect-select': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    };

    const smallControlSx = {
      ...controlSx,
      width: {
        xs: 'calc(50% - 22px)',
        sm: 110,
      },
    };

    const mediumControlSx = {
      ...controlSx,
      width: {
        xs: 'calc(50% - 22px)',
        sm: 180,
      },
    };

    const dateControlSx = {
      ...controlSx,
      width: {
        xs: 'calc(50% - 24px)',
        sm: 130,
      },
    };

    const tableContainerSx = {
      flex: 1,
      minHeight: 0,
      overflow: 'auto',
      borderTop: '1px solid rgba(15, 23, 42, 0.06)',
      '&::-webkit-scrollbar': {
        height: 8,
        width: 8,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(15, 23, 42, 0.18)',
        borderRadius: 999,
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'rgba(15, 23, 42, 0.04)',
      },
    };

    const tableSx = {
      minWidth: '100%',
      width: '100%',
      tableLayout: {
        xs: 'fixed',
        md: 'auto'
      },
      '& .MuiTableCell-root': {
        borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
        fontSize: {
          xs: '0.8rem',
          sm: '0.88rem',
          md: '0.92rem',
        },
      },
      '& .MuiTableRow-hover:hover': {
        backgroundColor: 'rgba(26, 35, 126, 0.035)',
      },
    };

    const headerCellSx = {
      py: {
        xs: 0.5,
        sm: 0.85,
      },
      px: {
        xs: 0.35,
        sm: 1,
      },
      bgcolor: '#f8fafc',
      color: '#1a237e',
      fontWeight: 650,
      lineHeight: 1.15,
      whiteSpace: 'normal',
      overflow: 'visible',
      textOverflow: 'clip',
    };

    const bodyCellSx = {
      py: {
        xs: 0.55,
        sm: 0.8,
      },
      px: {
        xs: 0.35,
        sm: 1,
      },
      whiteSpace: 'nowrap',
      color: '#111827',
      fontWeight: 450,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontVariantNumeric: 'tabular-nums',
    };

    const paginationSx = {
      flexShrink: 0,
      borderTop: '1px solid rgba(15, 23, 42, 0.06)',
      bgcolor: '#fff',
      minHeight: {
        xs: 44,
        sm: 52,
      },
      '& .MuiTablePagination-toolbar': {
        minHeight: {
          xs: 44,
          sm: 52,
        },
        px: {
          xs: 0.5,
          sm: 1,
        },
        flexWrap: {
          xs: 'wrap',
          sm: 'nowrap',
        },
        gap: {
          xs: 0.25,
          sm: 0.5,
        },
      },
      '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
        fontSize: {
          xs: '0.88rem',
          sm: '0.92rem',
          md: '1rem',
        },
        m: 0,
      },
      '& .MuiTablePagination-actions': {
        ml: {
          xs: 0,
          sm: 1,
        },
      },
    };

    return (
      <Card
        variant="outlined"
        sx={{
          position: 'relative',
          width: '100%',
          height: {
            xs: 600,
            sm: 600,
            md: 620,
            lg: 640,
          },
          maxHeight: {
            xs: 600,
            sm: 600,
            md: 620,
            lg: 640,
          },
          minHeight: 0,
          borderRadius: {
            xs: '14px',
            sm: '16px',
          },
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
          border: '1px solid rgba(15, 23, 42, 0.06)',
          bgcolor: '#fff',
        }}
      >
        <Box
          sx={{
            px: {
              xs: 0.75,
              sm: 1,
            },
            py: {
              xs: 0.65,
              sm: 0.85,
            },
            flexShrink: 0,
            borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
            bgcolor: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: {
                xs: 'stretch',
                sm: 'center',
              },
              justifyContent: 'space-between',
              gap: {
                xs: 0.75,
                sm: 1,
              },
              flexDirection: {
                xs: 'column',
                sm: 'row',
              },
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  color: '#1a237e',
                  fontWeight: 800,
                  fontSize: {
                    xs: '0.9rem',
                    sm: '1rem',
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Category Sales
              </Typography>

              <Typography
                sx={{
                  mt: 0.15,
                  color: '#64748b',
                  fontWeight: 600,
                  fontSize: {
                    xs: '0.72rem',
                    sm: '0.78rem',
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Category sales by location or by date
              </Typography>
            </Box>

            <Tabs
              value={this.state.value}
              onChange={this.handleChange}
              aria-label="category sales tabs"
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                minHeight: 36,
                maxWidth: {
                  xs: '100%',
                  sm: 220,
                },
                '& .MuiTabs-flexContainer': {
                  gap: 0.5,
                },
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
                '& .MuiTab-root': {
                  minHeight: 34,
                  minWidth: 72,
                  px: {
                    xs: 1,
                    sm: 1.25,
                  },
                  py: 0,
                  borderRadius: 999,
                  textTransform: 'none',
                  fontWeight: 750,
                  fontSize: {
                    xs: '0.76rem',
                    sm: '0.84rem',
                  },
                  color: '#64748b',
                  border: '1px solid transparent',
                },
                '& .MuiTab-root.Mui-selected': {
                  color: '#1a237e',
                  bgcolor: 'rgba(26, 35, 126, 0.08)',
                  borderColor: 'rgba(26, 35, 126, 0.14)',
                },
              }}
            >
              <Tab label="Location" value="1" />
              <Tab label="Date" value="2" />
            </Tabs>
          </Box>
        </Box>

        {this.state.value === "1" && (
          <>
            <Box
              sx={{
                px: {
                  xs: 0.75,
                  sm: 1,
                },
                py: {
                  xs: 0.75,
                  sm: 1,
                },
                borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
                bgcolor: '#fff',
                flexShrink: 0,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: {
                    xs: 0.75,
                    sm: 1,
                  },
                  flexWrap: 'wrap',
                  maxHeight: {
                    xs: 122,
                    sm: 96,
                  },
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  pr: 0.25,
                  '&::-webkit-scrollbar': {
                    width: 8,
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(15, 23, 42, 0.18)',
                    borderRadius: 999,
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: 'rgba(15, 23, 42, 0.04)',
                  },
                }}
              >
                <TextField
                  id="standard-select-period"
                  select
                  defaultValue="today"
                  variant="outlined"
                  size="small"
                  sx={smallControlSx}
                  onChange={this.selectPeriod}
                >
                  {period.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  id="standard-select-category"
                  select
                  defaultValue="0"
                  variant="outlined"
                  size="small"
                  sx={mediumControlSx}
                  onChange={this.selectCategory}
                >
                  {categorys.map((option) => (
                    <MenuItem key={option.iref} value={option.iref}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  id="standard-select-delivery"
                  select
                  defaultValue="2"
                  variant="outlined"
                  size="small"
                  sx={smallControlSx}
                  onChange={this.selectDelivery}
                >
                  {deliverys.map((option) => (
                    <MenuItem key={option.iref} value={option.iref}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>

                <Tooltip title="Download CSV">
                  <Button
                    size="small"
                    onClick={this.onDownload}
                    variant="contained"
                    sx={{
                      display: {
                        xs: 'none',
                        sm: 'inline-flex',
                      },
                      minWidth: 36,
                      width: 36,
                      height: 36,
                      p: 0,
                      flexShrink: 0,
                      borderRadius: '12px',
                      color: '#1a237e',
                      bgcolor: 'rgba(26, 35, 126, 0.08)',
                      boxShadow: 'none',
                      border: '1px solid rgba(26, 35, 126, 0.12)',
                      '&:hover': {
                        bgcolor: 'rgba(26, 35, 126, 0.12)',
                        boxShadow: 'none',
                      },
                    }}
                  >
                    <FileDownloadIcon fontSize="small" />
                  </Button>
                </Tooltip>

                <Box
                  sx={{
                    ...this.state.sx_hidden,
                    alignItems: 'center',
                    gap: 0.75,
                    flexWrap: 'wrap',
                  }}
                >
                  <TextField
                    size="small"
                    id="date-from"
                    label="From"
                    type="date"
                    value={this.state.dateFrom}
                    variant="outlined"
                    sx={dateControlSx}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      min: "2020-01-01",
                      style: {
                        paddingRight: 5,
                        paddingLeft: 5
                      }
                    }}
                    onChange={this.addDateFrom}
                  />

                  <TextField
                    size="small"
                    id="date-to"
                    label="To"
                    type="date"
                    value={this.state.dateTo}
                    variant="outlined"
                    sx={dateControlSx}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      min: "2020-01-01",
                      max: addDays(this.state.dateFrom, 50),
                      style: {
                        paddingRight: 5,
                        paddingLeft: 5
                      }
                    }}
                    onChange={this.addDateTo}
                  />

                  <Tooltip title="Refresh">
                    <Button
                      color="inherit"
                      onClick={() => this.doSync()}
                      variant="contained"
                      sx={{
                        minWidth: 36,
                        width: 36,
                        height: 36,
                        p: 0,
                        flexShrink: 0,
                        borderRadius: '12px',
                        boxShadow: 'none',
                        '&:hover': {
                          boxShadow: 'none',
                        },
                      }}
                    >
                      <AutorenewIcon fontSize="small" />
                    </Button>
                  </Tooltip>
                </Box>
              </Box>
            </Box>

            <TableContainer sx={tableContainerSx}>
              <Table stickyHeader aria-label="category sales location table" sx={tableSx}>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        ...headerCellSx,
                        width: {
                          xs: '44%',
                          sm: '52%',
                        },
                      }}
                    >
                      Location
                    </TableCell>

                    <TableCell
                      align="right"
                      sx={{
                        ...headerCellSx,
                        width: {
                          xs: '26%',
                          sm: '23%',
                        },
                      }}
                    >
                      Qty
                    </TableCell>

                    <TableCell
                      align="right"
                      sx={{
                        ...headerCellSx,
                        width: {
                          xs: '30%',
                          sm: '25%',
                        },
                      }}
                    >
                      Value
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(this.state.rowsPerPage > 0
                    ? categorySalesList.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                    : categorySalesList
                  ).map((category) => {
                    return (
                      <TableRow hover key={category.id} tabIndex={-1}>
                        <TableCell
                          sx={{
                            ...bodyCellSx,
                            fontWeight: 550,
                            fontVariantNumeric: 'normal',
                          }}
                        >
                          {category.name}
                        </TableCell>

                        <TableCell align="right" sx={bodyCellSx}>
                          {category.quantity}
                        </TableCell>

                        <TableCell align="right" sx={bodyCellSx}>
                          {category.value}
                        </TableCell>
                      </TableRow>
                    );
                  })}

                  {categorySalesList.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        <Box
                          sx={{
                            py: 4,
                            color: 'text.secondary',
                            fontSize: {
                              xs: '0.86rem',
                              sm: '0.92rem',
                            },
                          }}
                        >
                          No data
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[10, { value: -1, label: 'All' }]}
              labelRowsPerPage="Rows:"
              component="div"
              count={categorySalesList.length}
              rowsPerPage={this.state.rowsPerPage}
              page={this.state.page}
              onPageChange={this.handleChangePage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
              sx={paginationSx}
            />
          </>
        )}

        {this.state.value === "2" && (
          <Box
            sx={{
              flex: '1 1 auto',
              minHeight: 0,
              overflow: 'hidden',
              bgcolor: '#fff',
              p: {
                xs: 0,
                sm: 0.75,
              },

              '& > *': {
                height: '100%',
                maxHeight: '100%',
                minHeight: 0,
              },

              '& .MuiCard-root, & .MuiPaper-root, & .MuiCardContent-root': {
                height: '100%',
                maxHeight: '100%',
                minHeight: 0,
                boxShadow: 'none',
                borderRadius: {
                  xs: 0,
                  sm: '14px',
                },
              },

              '& .MuiTableContainer-root': {
                maxHeight: 'none',
                flex: 1,
                minHeight: 0,
                overflow: 'auto',
              },
            }}
          >
            <CategDateChartGroup />
          </Box>
        )}
      </Card>
    );
  }
}

export default CategLocationChartGroup;
